// Functionality of display product images using metafield above add to cart button on the PDP page.
$(document).ready(function() {
  // show first thumbnail-image-title and thumbnail-image-data by default
  $('.thumbnail-image-title').first().addClass('show-title');
  $('.thumbnail-image-data').first().addClass('selected-image');

  $('.thumbnail-image-data').hover(function() {
    // $(this).siblings('.thumbnail-image-title').addClass('show-title');

      
    if (!$(this).is(':first-child')) {
      $('.thumbnail-image-title').first().removeClass('show-title');
    }
    $(this).siblings('.thumbnail-image-title').addClass('show-title');
    
    if (!$(this).is(':first-child')) {
      $('.thumbnail-image-data').first().removeClass('selected-image');
    }
    $(this).addClass('selected-image');
  }, function() {
   // $(this).siblings('.thumbnail-image-title').removeClass('show-title');
    $('.thumbnail-image-title').first().addClass('show-title');
    $(this).siblings('.thumbnail-image-title').removeClass('show-title');

    $('.thumbnail-image-data').first().addClass('selected-image');
    $(this).removeClass('selected-image');
  });
});